import { IParty } from '../../../../../../ui-toolkit/orders/interfaces/IParty';
import { useContext, useMemo } from 'react';
import { filteredTextCallback } from './useGetFilteredParties';
import { SummaryContext } from '../../../../../shared/Summary/summaryContext';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';
import { ePartyPurpose } from '../../../../../../ui-toolkit/enums/ePartyPurpose';

const setOfBorrowerBuyerSellers = new Set<ePartyPurpose>([
  ePartyPurpose.borrower,
  ePartyPurpose.buyer,
  ePartyPurpose.seller,
]);
export const useGetFilteredBorrowerSellerParties = (): IParty[] => {
  const { filterText } = useContext(SummaryContext);
  const {
    data: { parties },
  } = useSelectCurrentOrder();
  const borrowersSellers = useMemo(() => {
    return parties.filter((p) => setOfBorrowerBuyerSellers.has(p.purpose));
  }, [parties]);
  return useMemo(() => {
    const filterCallback = filteredTextCallback(filterText);
    return borrowersSellers.filter(filterCallback);
  }, [filterText, borrowersSellers]);
};
